import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { GetBusTransactionDetails } from "../../Services/BusAPI";

const ThankyouBus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }

  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const key = getParamIgnoreCase("key");
  const clientCode = getParamIgnoreCase("clientCode");
  const [data, setData] = useState(null);

  // ? Query params



  // ? Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ? Fetch API
  useEffect(() => {
    if (referenceNo && key && clientCode) {
      fetchData();
    }
  }, [referenceNo, key, clientCode]);

  const fetchData = async () => {
    try {
      const params = {
        clientCode: clientCode,
        key: key,
        referenceNo: referenceNo, // ? IMPORTANT (case-sensitive)
      };

      const res = await GetBusTransactionDetails(params);

      //console.log("FULL API RESPONSE:", res); // ? DEBUG

      setData(res);
    } catch (err) {
      console.error("API ERROR:", err);
    }
  };

  // ? SAFE DATA HANDLING (handles ALL API formats)
  const booking = data?.booking || {};

  const passengers =
    data?.passengers ||
    data?.data?.passengers ||
    data?.booking?.passengers ||
    [];

  const bookingPoints =
    data?.bookingPoints ||
    data?.booking?.bookingPoints ||
    {};

  const payments = data?.payments?.[0] || {};
  // ? DEBUG AFTER DATA LOAD
  useEffect(() => {
    if (data) {
      //console.log("FINAL DATA:", data);
      //console.log("PASSENGERS:", passengers);
    }
  }, [data]);

  const formatTime = (dateTime) => {
    if (!dateTime) return "-";
    return new Date(dateTime).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (dateTime) => {
    if (!dateTime) return "-";
    return new Date(dateTime).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <Header />

      <section className="Booking_flight">
        <div className="container">
          <div className="box_shadow">

            {/* ? TITLE */}
            <div className="booking-confirmation clearfix mt-5">
              <h2>Thank you for booking your Bus Ticket with us.</h2>

              <h6 className='ruler'>Boarding Information</h6>
              {booking && (
                <table className="table table-bordered mt-5">
                  <thead>
                    <tr>
                      <th>Origin</th>
                      <th>Destination</th>
                      <th>Operator Name</th>
                      <th>Bus Type</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>{bookingPoints?.boardingPointLocation || "-"}</td>
                      <td>{bookingPoints?.droppingPointLocation || "-"}</td>
                      <td>{booking?.operatorName || "-"}</td>
                      <td>{booking?.busType || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              )}

              <h6 className='ruler'>Trip Information</h6>
              <table className="table table-bordered mt-5">
                <thead>
                  <tr>
                    <th>Pnr No</th>
                    <th>Booking Status</th>
                    <th>Journey Date</th>
                    <th>Pax Count</th>
                    <th>Departure</th>
                    <th>Arrival</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{booking?.pnr || "-"}</td>
                    <td>{booking?.bookingStatus || "-"}</td>
                    <td>
                      {booking?.journeyDate
                        ? (() => {
                          const [datePart] = booking.journeyDate.split(" ");
                          const [day, month, year] = datePart.split("-");
                          const formattedDate = new Date(`${year}-${month}-${day}`);
                          return formattedDate.toLocaleDateString("en-GB");
                        })()
                        : "-"}
                    </td>
                    <td>
                      {passengers?.length}
                    </td>
                    <td>{formatDate(bookingPoints?.boardingPointTime)} |{" "}
                      {formatTime(bookingPoints?.boardingPointTime)}</td>
                    <td>{formatDate(bookingPoints?.droppingPointTime)} |{" "}
                      {formatTime(bookingPoints?.droppingPointTime)}</td>
                  </tr>
                </tbody>
              </table>

              <h6 className='ruler'>Traveler Information</h6>
              {passengers?.length > 0 && (
                <div className="term-description">

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Traveler Name</th>
                        <th>Age</th>
                        <th>Gender</th>
                        <th>Seat No</th>
                        <th>Contact Number</th>
                        <th>Email ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {passengers.length > 0 && (
                        passengers.map((p, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {`${p.title || ""} ${p.firstName || ""} ${p.lastName || ""}`}
                            </td>
                            <td>{p.age || "-"}</td>
                            <td>{p.gender || "-"}</td>
                            <td>{p.seatNo || "-"}</td>
                            <td>{booking?.mobile || "-"}</td>
                            <td>{booking?.emailId || "-"}</td>
                          </tr>
                        )))}
                    </tbody>
                  </table>
                </div>
              )}

              <h6 className='ruler'>Payment Information</h6>
              {payments && (
                <div className="term-description">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Payment Status</th>
                        <th>Payment Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ color: "red" }}>{payments.paymentStatus}</td>
                        <td><i className="fa fa-inr"></i> {Math.round(payments.amountPaid)}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              )}
            </div>


            {/* ? VIEW DETAILS BUTTON */}
            <div className="col-md-12 text-right">
              <a className="redirect" title="Click here for Booking Detail"
                href={`/reservations/bus/TransactionsDetails?referenceNo=${referenceNo}&clientCode=${clientCode}&key=${key}`} >View Booking Details </a>
            </div>
            {/* <div className="col-md-12 mt-5">
              <span
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() =>
                  navigate(
                    `/reservations/bus/TransactionsDetails?referenceNo=${referenceNo}&clientCode=${clientCode}&key=${key}`
                  )
                }
              >
                View Booking Details ?
              </span>
            </div> */}

          </div>
        </div>
      </section>
    </>
  );
};

export default ThankyouBus;